import { render, staticRenderFns } from "./set.vue?vue&type=template&id=550c12fb&scoped=true"
import script from "./set.js?vue&type=script&lang=js&external"
export * from "./set.js?vue&type=script&lang=js&external"
import style0 from "./set.vue?vue&type=style&index=0&id=550c12fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c12fb",
  null
  
)

export default component.exports